import Api from '@utils/api';
import { ExamenesAspirantes } from '@constants/urls';

export const state = {
	aspirantes: [],
	examenAspirante: {
		areasDeConocimiento: []
	},
	examenAspiranteResultado: {
		areasDeConocimiento: []
	},
	loading: false,
	loading_action: false
};

export const getters = {
	getAspirantes(state) {
		return state.aspirantes;
	},
	getExamenAspirante(state) {
		return state.examenAspirante;
	},
	getExamenAspiranteResultado(state) {
		return state.examenAspiranteResultado;
	},
	getLoading(state) {
		return state.loading;
	},
	getLoadingAction(state) {
		return state.loading_action;
	}
};

export const mutations = {
	SET_ASPIRANTES(state, newValue) {
		state.aspirantes = newValue;
	},
	SET_EXAMEN_ASPIRANTE(state, newValue) {
		state.examenAspirante = newValue;
	},
	SET_EXAMEN_ASPIRANTE_RESULTADOS(state, newValue) {
		state.examenAspiranteResultado = newValue;
	},
	SET_LOADING_FILES(state, newValue) {
		state.loading_action = newValue;
	},
	SET_LOADING(state, newValue) {
		state.loading = newValue;
	}
};

export const actions = {
	obtenerAspirantes({ commit }, { clave, onComplete, onError }) {
		commit('SET_LOADING', true);
		Api.Get(ExamenesAspirantes.OBTENER_ASPIRANTES(clave))
			.then((response) => {
				commit('SET_ASPIRANTES', response.data.data);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	obtenerExamenAspirantesResultados(
		{ commit },
		{ clave, onComplete, onError }
	) {
		commit('SET_LOADING', true);
		Api.Get(ExamenesAspirantes.OBTENER_ASPIRANTES_RESULTADOS(clave))
			.then((response) => {
				commit('SET_ASPIRANTES', response.data.data);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	subirArchivoAspirantesCsv(
		{ commit },
		{ clave, archivos, onComplete, onError }
	) {
		commit('SET_LOADING_FILES', true);
		Api.PostFile(ExamenesAspirantes.CREAR_ASPIRANTES(clave), archivos)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarTodosAspirantes({ commit }, { clave, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(ExamenesAspirantes.ELIMINAR_TODOS_ASPIRANTES(clave))
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarAspirantes({ commit }, { clave, ficha, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(ExamenesAspirantes.ELIMINAR_ASPIRANTE(clave, ficha))
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	asignarExamenAspirante({ commit }, { ficha, data, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Post(ExamenesAspirantes.ASOCIAR_ASPIRANTES(ficha), data)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	obtenerExamenAspirante({ commit }, { clave, ficha, onComplete, onError }) {
		commit('SET_LOADING', true);
		Api.Get(ExamenesAspirantes.OBTENER_EXAMEN_ASPIRANTE(clave, ficha))
			.then((response) => {
				commit('SET_EXAMEN_ASPIRANTE', response.data.data);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	obtenerExamenAspiranteResultados(
		{ commit },
		{ clave, ficha, onComplete, onError }
	) {
		commit('SET_LOADING', true);
		Api.Get(ExamenesAspirantes.OBTENER_ASPIRANTE_RESULTADO(ficha))
			.then((response) => {
				commit('SET_EXAMEN_ASPIRANTE_RESULTADOS', response.data.data);
				onComplete(response);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	obtenerExamenesAspirantesResultadosSinState(
		{ commit },
		{ clave, ficha, onComplete, onError }
	) {
		commit('SET_LOADING', true);
		Api.Get(ExamenesAspirantes.OBTENER_ASPIRANTES_RESULTADOS_DETALLE(clave))
			.then((response) => {
				onComplete(response);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	descargarCSVResultadosGlobales({ commit }, { clave, onComplete }) {
		Api.PostBlob(
			ExamenesAspirantes.DESCARGAR_CSV_RESULTADOS_GLOBALES(clave)
		).then((response) => {
			onComplete(response);
		});
	}
};
